{
	"title": "Объяснить по фото",
	"subtitle": "Загрузи фото графика, формулы или задачи — получи объяснение с LaTeX и follow-up Q&A.",
	"newCta": "Новый разбор",
	"list": {
		"empty": {
			"title": "Нет разборов",
			"subtitle": "Сфотографируй задачу или загрузи изображение — AI распознает и объяснит.",
			"cta": "Загрузить изображение"
		},
		"search": "Поиск по названию…",
		"count": "{count, plural, one {# разбор} few {# разбора} other {# разборов}}",
		"errorTitle": "Не удалось загрузить разборы",
		"errorSubtitle": "Проверь соединение или попробуй позже.",
		"retry": "Повторить"
	},
	"filter": {
		"category": "Категория",
		"status": "Статус",
		"all": "Все"
	},
	"category": {
		"problem": "Задача",
		"graph": "График",
		"formula": "Формула",
		"handwriting": "Рукопись",
		"diagram": "Схема",
		"photo": "Фото",
		"other": "Другое"
	},
	"status": {
		"queued": "В очереди",
		"analyzing": "Анализ",
		"ready": "Готово",
		"failed": "Ошибка"
	},
	"upload": {
		"title": "Новый разбор",
		"subtitle": "Загрузи или сфотографируй изображение, при необходимости — обрежь нужный фрагмент.",
		"step": {
			"source": "Источник",
			"crop": "Обрезка",
			"progress": "Анализ"
		},
		"source": {
			"file": "Файл",
			"camera": "Камера",
			"gallery": "Галерея",
			"capture": "Сфотографировать",
			"flipCamera": "Переключить камеру",
			"drop": "Перетащи изображение",
			"dropFile": "Перетащи файл сюда или нажми, чтобы выбрать",
			"or": "или",
			"fromMaterial": "Из материала"
		},
		"cropHint": "По умолчанию AI разберёт всё изображение. Приблизь и сдвинь картинку, чтобы выделить нужный фрагмент.",
		"cropFirst": "Сначала обрежь область для анализа",
		"cropTool": "Обрезка",
		"resetCrop": "Вся картинка",
		"zoom": "Масштаб",
		"hintLabel": "Подсказка для AI (опц.)",
		"hintPlaceholder": "Например: «это график функции из лекции по матану»",
		"analyze": "Разобрать",
		"back": "Назад",
		"cancel": "Отмена",
		"tip": "Чем чётче фрагмент — тем точнее разбор.",
		"uploading": "Загружаем изображение…",
		"queued": "Поставлено в очередь…",
		"analyzing": "AI анализирует изображение…",
		"openAnalysis": "Открыть разбор",
		"progressHint": "Обычно занимает 10–20 секунд. Можно закрыть окно — разбор продолжится в фоне."
	},
	"crop": {
		"zoom": "Масштаб",
		"rotate": "Повернуть",
		"confirm": "Подтвердить обрезку"
	},
	"latex": {
		"copy": "Скопировать LaTeX",
		"copied": "LaTeX скопирован"
	},
	"materialPicker": {
		"title": "Выбор из материала",
		"selectMaterial": "Выбери материал (PDF или изображение)",
		"selectPage": "Выбери страницу",
		"thumbnailLoading": "Загружаем превью…",
		"noPdfMaterials": "У тебя пока нет PDF-материалов",
		"noMaterials": "У вас пока нет материалов в формате PDF или изображений",
		"noFigures": "Превью страниц ещё не извлечены. Попробуй позже.",
		"kindImage": "изображение",
		"useImage": "Использовать это изображение",
		"page": "Стр. {page}",
		"continue": "Продолжить",
		"back": "Назад к материалу"
	},
	"detail": {
		"back": "К списку",
		"loading": "Загружаем разбор…",
		"analyzing": {
			"title": "Анализируем изображение",
			"subtitle": "Обычно занимает 10–20 секунд.",
			"steps": {
				"ocr": "Распознавание",
				"categorize": "Определение типа",
				"explain": "Создание объяснения"
			}
		},
		"explanation": "Объяснение",
		"keyPoints": "Главное",
		"ocrText": "Распознанный текст",
		"imageSource": "Исходное изображение",
		"copyToNote": "Сохранить в конспект",
		"zoom": {
			"in": "Увеличить",
			"out": "Уменьшить",
			"reset": "Сбросить"
		},
		"errorTitle": "Не удалось загрузить разбор",
		"failedTitle": "Анализ не удался",
		"failedSubtitle": "Похоже на временный сбой ИИ. Можно повторить — изображение уже загружено.",
		"retry": "Повторить анализ",
		"retrying": "Запускаем повтор…"
	},
	"saveToNote": {
		"success": "Конспект создан",
		"openNote": "Открыть",
		"error": "Не удалось создать конспект"
	},
	"askTutor": {
		"cta": "Спросить репетитора",
		"disclaimer": "Ответы генерируются ИИ и могут содержать ошибки. Для экзаменационных, олимпиадных и иных сложных задач рекомендуется дополнительно проверять решение.",
		"chips": {
			"simpler": "Объясни проще",
			"deeper": "Объясни подробнее",
			"steps": "Разбери по шагам"
		},
		"prompts": {
			"simpler": "Объясни проще эту задачу: «{subject}».",
			"simplerNoTitle": "Объясни проще объяснение по этому изображению.",
			"deeper": "Объясни подробнее эту задачу: «{subject}».",
			"deeperNoTitle": "Объясни подробнее объяснение по этому изображению.",
			"steps": "Разбери по шагам решение этой задачи: «{subject}».",
			"stepsNoTitle": "Разбери по шагам решение задачи на этом изображении."
		}
	},
	"card": {
		"actions": "Действия"
	},
	"delete": {
		"title": "Удалить разбор?",
		"subtitle": "Разбор попадёт в корзину на 30 дней.",
		"confirm": "Удалить",
		"cancel": "Отмена",
		"success": "Разбор удалён"
	},
	"mermaid": {
		"rendering": "Диаграмма…",
		"error": "Не удалось отобразить диаграмму",
		"showSource": "Показать исходник",
		"copy": "Копировать исходник",
		"copied": "Скопировано",
		"fullscreen": "Открыть на весь экран",
		"download": "Скачать PNG",
		"downloadError": "Не удалось скачать PNG"
	},
	"errors": {
		"heicConversionFailed": "Не удалось конвертировать HEIC. Сохрани файл как JPG и попробуй снова.",
		"uploadFailed": "Не удалось загрузить изображение",
		"processingFailed": "Не удалось обработать изображение",
		"unsupportedFormat": "Формат не поддерживается. JPG · PNG · WEBP · HEIC.",
		"fileTooLarge": "Файл слишком большой. Максимум 10 МБ.",
		"noFile": "Сначала выбери файл",
		"deleteFailed": "Не удалось удалить",
		"cameraPermissionDenied": "Доступ к камере запрещен. Разрешите доступ в настройках браузера или приложения.",
		"cameraNotFound": "На этом устройстве не найдена камера.",
		"cameraFailed": "Не удалось открыть камеру"
	},
	"intro": {
		"title": "Снимок вместо вопроса",
		"body": "Разбор строится по тому, что на снимке: у графика читаются оси и тренд, у задачи — ход решения. Рукописное тоже распознаётся.",
		"bullets": [
			"Страницу можно взять из уже загруженного материала",
			"Снимок с камеры годится: HEIC конвертируется сам",
			"Готовый разбор сохраняется в конспект одним действием"
		]
	}
}
